import apps from "@services/applications";

export default [
  {
    path: "/app/translation-manager/:translationProjectId?",
    name: "translation-manager",
    props: true,
    meta: {
      module: "translation-manager",
      application: apps.Modules.TranslationManager.Id,
      title: apps.Modules.TranslationManager.Name,
      licenseName: "TranslationManager"
    },
    component: () => import("@TranslationManager/views/TranslationManager.vue"),
    children: []
  }
];
